import { applyMiddleware } from 'redux';
import permissionReducer from './reducers/permissionReducer';
import { createStore, combineReducers } from 'redux';
import { IAuth } from './actions/auth';
import { ILoadAlbum } from './actions/albumAction';
import albumReducer from './reducers/albumReducer';
import { IProductGrid } from './actions/productGridActions';
import productGridReducer from './reducers/productGridReducer';

const rootReducer = combineReducers({
  auth: permissionReducer,
  loadAlbumState: albumReducer,
  productGridState: productGridReducer,
});
export interface IStoreState {
  auth: IAuth;
  loadAlbumState: ILoadAlbum;
  productGridState: IProductGrid;
}
const store = createStore(rootReducer, {}, applyMiddleware());
export default store;
